import React from "react";
import styles from "./TopBar.module.css";
import SearchBar from "../searchBar/SearchBar";
import CommonDropdown from "../dropdown/CommonDropdown";
import { useEffect, useRef } from "react";
import { Link } from "@mui/material";

const TopBar = ({
  searchParams,
  typeFilter,
  packageFilter,
  industryFilter,
  organisationFilter,
  reportFilter,
  organisationsFilter,
  accessFilter,
  reportPackageFilter,
  categoryFilter,
  isVfAdmin,
  placeholder,
  clearFilter = true
}) => {
  const categorySelectRef = useRef();
  const orgSelectRef = useRef();
  const typeSelectRef = useRef();
  const industrySelectRef = useRef();
  const packageSelectRef = useRef();
  const accessSelectRef = useRef();
  const reportsSelectRef = useRef();
  const clearFilters = () =>{
    categorySelectRef?.current?.clearSelectedItems();
    orgSelectRef?.current?.clearSelectedItems();
    typeSelectRef?.current?.clearSelectedItems();
    industrySelectRef?.current?.clearSelectedItems();
    packageSelectRef?.current?.clearSelectedItems();
    accessSelectRef?.current?.clearSelectedItems();
    reportsSelectRef?.current?.clearSelectedItems();
  };
  return (
    <div className={styles.topHeader}>
      <div className={styles.topheaderLeft}>
        <SearchBar placeholder={placeholder} />
      </div>
      <div className={styles.topheaderRight}>
        <div className={styles.link}>
        {clearFilter && <Link onClick = {clearFilters}>Clear Filters</Link>}
        </div>
        <div className={styles.fieldWrap}>
          {/* <SearchBar /> */}
          {typeFilter && <CommonDropdown ref={typeSelectRef} name="Type" options={typeFilter} />}
          {industryFilter && (
            <CommonDropdown ref={industrySelectRef} name="Industry" options={industryFilter} />
          )}
          {packageFilter && (
            <CommonDropdown ref={packageSelectRef} name="Package" options={packageFilter} />
          )}
          {organisationFilter && isVfAdmin && searchParams === "/admin" && (
            <CommonDropdown ref={orgSelectRef} name="Organisation" options={organisationFilter} />
          )}
          {categoryFilter && searchParams !== "/admin" && (
            <CommonDropdown ref={categorySelectRef} name="Category" options={categoryFilter} />
          )}
          {accessFilter && (
            <CommonDropdown ref={accessSelectRef} name="Access" options={accessFilter} />
          )}
          {reportPackageFilter && isVfAdmin && (
            <CommonDropdown ref={packageSelectRef} name="Package" options={reportPackageFilter} />
          )}
          {reportFilter && (
            <CommonDropdown ref={reportsSelectRef} name="Reports" options={reportFilter} />
          )}
          {organisationsFilter && (
            <CommonDropdown ref={orgSelectRef}
              name="Organisations"
              options={organisationsFilter}
            />
          )}
        </div>
        {/* <div className={styles.groupDiv}>
                <AddNewDropdown />
              </div> */}
      </div>
    </div>
  );
};

export default TopBar;

// const packageOptions = [
//   { label: "Package", value: "" },
//   { label: "Basic", value: "basic" },
//   { label: "Advance", value: "advance" },
// ];

// const typeOptions = [
//   { label: "Type", value: "" },
//   { label: "Charity", value: "Charity" },
//   { label: "Higher Education", value: "Higher Education" },
//   { label: "Schools K-12", value: "Schools K-12" },
//   { label: "Government", value: "Government" },
//   { label: "Health", value: "health" },
//   { label: "Other", value: "Other" },
// ];
